<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M19.207 8.834H3.957c-.713 0-1.291-.448-1.291-1s.578-1 1.29-1h15.251a2.5 2.5 0 014.584 0h4.251c.713 0 1.29.448 1.29 1s-.577 1-1.29 1h-4.251a2.5 2.5 0 01-4.584 0zM4.114 15c-.708 0-1.282.448-1.282 1s.574 1 1.282 1H6.04a2.5 2.5 0 004.584 0H28.05c.708 0 1.282-.448 1.282-1s-.574-1-1.282-1H10.624a2.5 2.5 0 00-4.584 0H4.114zm-1.282 9.168c0-.552.574-1 1.282-1h6.926a2.5 2.5 0 014.584 0H28.05c.708 0 1.282.448 1.282 1s-.574 1-1.282 1H15.624a2.5 2.5 0 01-4.584 0H4.114c-.708 0-1.282-.448-1.282-1z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsAdjustOutline'
}
</script>
